import dayjs from 'dayjs'
import { useUserStore } from '@/pinia/user'
import { v4 as uuidv4 } from 'uuid'
import Cookies from 'js-cookie'

export const parseUrlParams = () => {
  // 获取问号后面的查询参数部分
  const url = window.location.search
  const queryString = url.split('?')[1]

  // 如果没有查询参数，返回空对象
  if (!queryString) {
    return {}
  }

  // 将查询参数部分拆分为键值对
  const params = queryString.split('&')
  const result = {}

  params.forEach((param) => {
    const [key, value] = param.split('=')
    result[decodeURIComponent(key)] = decodeURIComponent(value || '')
  })

  return result
}
/**
 * 设置 过期时间 过期返回false 没过期返回true
 * time 基础一天
 *
 */
export function timelocalStorage (value, time) {
  let status = true
  const newData = new Date().getTime() // 当前时间
  const local = Number(localStorage.getItem(`${value}`))
  if (local === 0 || (local > 0 && local <= newData)) {
    // 不存在 或者 存在过期了 设置新时间
    localStorage.setItem(`${value}`, (newData + time * 86400000).toFixed(0))
  } else if (local > 0 && local > newData) {
    status = false
  }
  return status
}

export function hanleEventName (value) {
  return value
    .replace(/\//g, '')
    .replace(/ {2}/g, ' ')
    .replace(/-/g, '_')
    .replace(/'/g, '_')
    .replace(/&/g, '_')
    .replace(/\?/g, '_')
    .replace(/\//g, '_')
    .replace(/:/g, '_')
    .replace(/,/g, '_')
}

const apiUrl = import.meta.env.VITE_API_URL
/**
 *
 * @param {*} name 事件名称
 * @param {*} category 事件分类
 * @param {*} ext 附加属性 {}
 */
export const gaAnalyticsMore = async (name, category, ext) => {
  try {
    const uid = useUserStore().userInfo.uid
    window.gtag('event', `${name}`, {
      event_category: `${category}`,
      event_label: `${name}`,
      bdUserId: `${uid}`,
      ...ext,
      ...parseUrlParams(),
      host_name: window.location.host,
      urlsearch: window.location.search
    }); // eslint-disable-line
  } catch (err) {}
}
/**
 *
 * @param {*} name 事件名称
 * @param {*} category 事件分类
 * @param {*} status 为true时
 */
export const gaAnalytics = async (names, categorys, ext) => {
  const name = hanleEventName(names).split(' ').join('_')
  const category = hanleEventName(categorys).split(' ').join('_')

  gaAnalyticsMore(name, category, ext)
}

const getOstype = () => {
  let os = 'Unknown OS'
  const userAgent = window.navigator.userAgent

  if (userAgent.indexOf('Windows NT') !== -1) {
    os = 'Windows'
  } else if (userAgent.indexOf('Macintosh') !== -1) {
    os = 'macOS'
  } else if (userAgent.indexOf('Linux') !== -1) {
    os = 'Linux'
  } else if (userAgent.indexOf('Android') !== -1) {
    os = 'Android'
  } else if (
    userAgent.indexOf('iPhone') !== -1 ||
    userAgent.indexOf('iPad') !== -1
  ) {
    os = 'iOS'
  }
  return os
}

const getBrowser = () => {
  const userAgent = window.navigator.userAgent
  let browser = 'Unknown Browser'

  // 检查不同的浏览器标识符
  if (userAgent.indexOf('Firefox') !== -1) {
    browser = 'Mozilla Firefox'
  } else if (userAgent.indexOf('Edg') !== -1) {
    browser = 'Microsoft Edge'
  } else if (
    userAgent.indexOf('Chrome') !== -1 &&
    userAgent.indexOf('Edg') === -1 &&
    userAgent.indexOf('OPR') === -1
  ) {
    browser = 'Google Chrome'
  } else if (
    userAgent.indexOf('Safari') !== -1 &&
    userAgent.indexOf('Chrome') === -1
  ) {
    browser = 'Safari'
  } else if (
    userAgent.indexOf('OPR') !== -1 ||
    userAgent.indexOf('Opera') !== -1
  ) {
    browser = 'Opera'
  } else if (
    userAgent.indexOf('MSIE') !== -1 ||
    userAgent.indexOf('Trident') !== -1
  ) {
    browser = 'Internet Explorer'
  }
  return browser
}

export const buriedPointUtil = async (props) => {
  const { uid, eventId, ...others } = props
  if (localStorage.getItem('deviceId') === null) {
    localStorage.setItem('deviceId', 'web' + Math.random().toString(36).substr(2))
  }
  await fetch(`${apiUrl}/buried-point/pushPoint/point`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      eventId,
      os: getOstype(),
      browser: getBrowser(),
      userId: useUserStore().userInfo.uid || uid || '',
      deviceId: localStorage.getItem('deviceId') || '',
      detail: {
        url: window.location.href,
        timestamp: +new Date(),
        ...others
      }
    })
  })
}

// 防抖函数
export const debounce = (fn, delay) => {
  let timer

  return function (...args) {
    // 清除上一次的定时器
    if (timer) {
      clearTimeout(timer)
    }

    // 设置新的定时器
    timer = setTimeout(() => {
      fn(...args) // 执行原函数
    }, delay)
  }
}

/**
 * TODO: 遗留代码，后续做 SEO 优化时移除
 * @param {String} str 需要打开的 URL
 */
export const openURLWithChannelQuery = (str = '') => {
  window.open(str, '_blank')
}

export const waitForIntercom = (orderNo) => {
  const interval = setInterval(() => {
    if (window?.Intercom) {
      // 调用 Intercom 方法
      window.Intercom('showNewMessage', `Order Number: ${orderNo}, pay the order amount.`)
      clearInterval(interval) // 清除定时器
    }
  }, 100) // 每 100ms 检查一次
}

/**
 * 取出现次数的id
 * @param {Array}
 * @returns {number}
 */
export const findMostFrequentCategory = (rows) => {
  const categoryCount = { third: {}, second: {}, top: {} }

  // 统计每个 category 的出现次数
  rows.forEach(({ thirdCategoryId, secondCategoryId, topCategoryId }) => {
    if (thirdCategoryId !== null) {
      categoryCount.third[thirdCategoryId] = (categoryCount.third[thirdCategoryId] || 0) + 1
    }
    if (secondCategoryId !== null) {
      categoryCount.second[secondCategoryId] = (categoryCount.second[secondCategoryId] || 0) + 1
    }
    if (topCategoryId !== null) {
      categoryCount.top[topCategoryId] = (categoryCount.top[topCategoryId] || 0) + 1
    }
  })

  // 获取每个 category 中出现最多的 id
  const getMostFrequentId = (categoryMap) => {
    return Object.entries(categoryMap).reduce((mostFrequentId, [id, count]) => {
      return count > (categoryMap[mostFrequentId] || 0) ? id : mostFrequentId
    }, null)
  }

  // 按优先级顺序返回出现最多的 ID
  let mostFrequentId = getMostFrequentId(categoryCount.third)
  if (!mostFrequentId) mostFrequentId = getMostFrequentId(categoryCount.second)
  if (!mostFrequentId) mostFrequentId = getMostFrequentId(categoryCount.top)

  return mostFrequentId
}

// 节流函数
export const throttle = (fn, delay) => {
  let lastTime = 0
  return function (...args) {
    const now = Date.now()
    if (now - lastTime >= delay) {
      lastTime = now
      fn.apply(this, args)
    }
  }
}

export const copyText = (text) => {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(() => {
        resolve(text)
      }).catch(err => {
        reject(err)
      })
    } else {
      const input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', text)
      document.body.appendChild(input)
      input.setSelectionRange(0, 9999)
      if (document.execCommand('copy')) {
        document.execCommand('copy')
      }
      document.body.removeChild(input)
      resolve(text)
    }
  })
}

// 银行家算法
export const bankersRound = (num, decimals = 2) => {
  // 处理特殊值
  if (isNaN(num) || !isFinite(num)) {
    return num
  }

  const factor = Math.pow(10, decimals)
  const value = num * factor

  // 获取小数部分
  const decimal = value - Math.floor(value)

  // 如果小数部分恰好是0.5
  if (Math.abs(decimal - 0.5) < Number.EPSILON) {
    // 向最近的偶数舍入
    const floor = Math.floor(value)
    return ((floor % 2 === 0 ? floor : floor + 1) / factor).toFixed(decimals)
  }

  // 其他情况使用四舍五入
  return (Math.round(value) / factor).toFixed(decimals)
}

/**
 * 银行家算法，并且返回值银行家算法计算后的值，或者最小值
 */
export const bankersRoundWithMax = (num, min = 0.01, decimals = 2) => {
  return bankersRound(Math.max(num, min), decimals)
}

export const setThemeColor = (color) => {
  let metaTag = document.querySelector('meta[name="theme-color"]')
  if (!metaTag) {
    metaTag = document.createElement('meta')
    metaTag.setAttribute('name', 'theme-color')
    document.head.appendChild(metaTag)
  }
  metaTag.setAttribute('content', color)
}

export const formatDate = (date, format = 'YYYY-MM-DD') => {
  return dayjs(date).format(format)
}

export const validateEmail = (email) => {
  const emailPattern = /^[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+$/
  return emailPattern.test(email)
}

/**
 * @deprecated 已废弃，使用 constants/isMobile 替代
 * 判断当前设备型号是否是 H5
 * @returns {boolean}
 */
export const isMobile = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return /iphone|ipod|ipad|android|blackberry|windows phone/i.test(userAgent)
}

/**
 * 上传 Meta 事件追踪数据
 * @param {string} eventId 事件 ID
 * @param {string} eventName 事件名称
 * @param {Object} eventData 事件数据
 * @param {string} pixelId 是否是特定的 pixel
 * @returns {Promise<void>}
 * @example
 * metaPixelTrack('Event Id', 'Purchase', {
 *   value: 100,
 *   currency: 'USD',
 *   contents: [{ id: '1234', quantity: 1 }],
 *   content_type: 'product'
 * })
 */
export const metaPixelTrack = (eventId, eventName, eventData = {}, pixelId) => {
  if (typeof window.fbq !== 'function') throw new Error('Meta Pixel SDK is not loaded')

  if (pixelId) {
    window.fbq(
      'trackSingle',
      pixelId,
      eventName,
      { event_type_id: eventId, ...eventData },
      { eventID: uuidv4() }
    )
  } else {
    window.fbq(
      'track',
      eventName,
      { event_type_id: eventId, ...eventData },
      { eventID: uuidv4() }
    )
  }
}

/**
 * 格式化销量
 * @param {number} volume 销量
 * @returns {string} 格式化后的销量字符串
 * @example
 * formatSalesVolume(10000) // '10k+'
 * formatSalesVolume(1500000) // '1.5m+'
 * formatSalesVolume(100) // 100
 */
export const formatSalesVolume = (volume) => {
  const value = Number(volume)
  if (value > 1_000_000) {
    return Math.floor(value / 1_000_000) + 'm+'
  } else if (value > 1_000) {
    return Math.floor(value / 1_000) + 'k+'
  } else {
    return value
  }
}

/**
 * 将 Number 类型转换成标准数量格式
 * @param {number} amount
 * @returns {string}
 * @example
 * formatAmount(1000) // '1,000'
 */
export const formatAmount = (amount) => Number(amount).toLocaleString('en-US')

/**
 * 格式化名称，将空格转换为-
 * @param {string} name
 * @returns {string}
 * @example
 * formatName('Hello World') // 'Hello-World'
 */
export const formatName = (name) => name.replace(/ /g, '-')

// 获取区间价对应价格
export const getPriceByQuantity = (quantity, priceRange) => {
  let validPrices = priceRange.filter(item => item.startQuantity <= quantity)
  if (validPrices.length === 0) {
    validPrices = [priceRange[0]]
  }

  const bestMatch = validPrices.reduce((prev, curr) =>
    curr.startQuantity > prev.startQuantity ? curr : prev
  )

  return Number(bestMatch.price)
}

/**
 * 打开指定链接并且自动设置 SSO 所需要的参数
 */
export const openURLWithSSO = (url, open = true) => {
  const token = useUserStore().userInfo.tk
  if (token) {
    const domain = import.meta.env.VITE_APP_ENV === 'production' ? '.bestdealer.com' : '.lerdex.co'

    Cookies.set('dsp.tk', token, {
      domain,
      path: '/',
      expires: 1
    })
  }
  const origin = import.meta.env.VITE_APP_BESTDEALER_URL
  const link = `${origin}/redirect/sso?redirect=${encodeURIComponent(url)}`
  if (open) {
    window.open(link, '_blank')
  } else {
    window.location.href = link
  }
}
